import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import LogoWithBackground from "@ats/src/components/shared/LogoWithBackground";
import { INTERNAL_UTM_PARAMS } from "@shared/lib/utils";

export default function FormLogoHeader() {
  return (
    <Styled.Container>
      <a href={`https://polymer.co${INTERNAL_UTM_PARAMS}`} className="app-header__logo" rel="noopener noreferrer">
        <LogoWithBackground variant="gradient" size={28} backgroundSize={50} />
      </a>
    </Styled.Container>
  );
}

/* Styled Components
======================================================= */
const Styled: any = {};

Styled.Container = styled.div((props) => {
  const t = props.theme;
  return css`
    label: FormLogoHeader;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 32px;
  `;
});
